module.exports = __webpack_public_path__ + "static/media/add-folder.582786ae.svg";